import { FieldMetadata } from 'models/forms/fields';
import { BlockMetadata } from 'models/metadata/block.definition';
import { QuoteFormError } from 'state/addonForm/addonForm.selector';
import { ProductNode } from 'state/product-description/model';
import { Width } from 'state/product-description/types';

export type EssentialWorkflowStatus =
  | 'creating'
  | 'not-ready'
  | 'ready'
  | 'price-in-progress'
  | 'price-rejected'
  | 'priced'
  | 'trade-in-progress'
  | 'price-expired'
  | 'trade-rejected'
  | 'traded';

export type EssentialBlockNode = Omit<ProductNode, 'children'> &
  BlockMetadata & {
    nodes: EssentialFormNode[];
    errors: QuoteFormError[];
    warnings: QuoteFormError[];
  };

export type EssentialFieldNode = Omit<ProductNode, 'children'> & FieldMetadata;

export type EssentialFormNode = EssentialBlockNode | EssentialFieldNode;

export function isEssentialBlockNode(node: EssentialFormNode): node is EssentialBlockNode {
  return 'nodes' in node;
}

export type FieldId = string;

export interface LayoutField {
  fieldId: FieldId;
  label: string;
  order: number;
  isPinned: boolean;
  isVisible: boolean;
  isOrderable: boolean; // replace isCustomizable
  isAlwaysVisible: boolean;
  width: Width;
  initialWidth: Width;
}

export interface LayoutSection {
  sectionId: string;
  label: string;
  fields: LayoutField[];
}

export type CustomFieldPreferences = {
  visibleFields: LayoutField[];
  additionalConfigurationFields: LayoutField[];
};
